import { render, staticRenderFns } from "./insureForm.vue?vue&type=template&id=2f2c7774&scoped=true"
import script from "./insureForm.vue?vue&type=script&lang=js"
export * from "./insureForm.vue?vue&type=script&lang=js"
import style0 from "./insureForm.vue?vue&type=style&index=0&id=2f2c7774&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2c7774",
  null
  
)

export default component.exports